import { forwardRef } from 'react';
import { StyledNavList } from './styled';

const NavList = forwardRef((props, ref) => (
  <StyledNavList ref={ref} {...props} />
));

export default NavList;
